import React, { useGlobal } from 'reactn'
import {
  SimpleGrid,
  Box,
  Container,
  Divider,
} from '@chakra-ui/react'
import { formatPrice } from '../../utils/format-price'
import { Dots } from './dotsAnimation'

const ShoppingCartTotals = ({ globalState }) => {
  const { store } = globalState
  const { ts, calculating, shippingID, cartTotal } = store
  console.log("STORE", store, cartTotal)
  // Show TBC if:
  // 1. Calculating (cart is being fetched)
  // 2. No shippingID selected (shipping needs to be recalculated after address change)
  // 3. No shipping price in totals (cart hasn't been fetched with current address)
  const showTBC = calculating || !shippingID || ts?.shipping_price === null

  return (
    <Box id="CartTotals">
      <Divider marginBottom={2} />
      <SimpleGrid columns={2}>
        <Container ml={0} mt={0} p={0} fontSize={14}>SHIPPING</Container>
        <Box pr={4} mt={0} fontSize={14} textAlign={'right'}>
          {formatPrice(showTBC ? null : ts?.shipping_price)}
        </Box>
      </SimpleGrid>
      {ts?.discount_price && ts?.pc !== false &&
        <SimpleGrid columns={2}>
          <Container ml={0} mt={0} p={0} fontSize={14}>DISCOUNT</Container>
          <Box pr={4} mt={0} fontSize={14} textAlign={'right'}>
            {formatPrice(showTBC ? null : ts.discount_price)}
          </Box>
        </SimpleGrid>
      }
      <SimpleGrid columns={2}>
        <Container ml={0} mt={0} p={0} fontSize={14}>TOTAL</Container>
        <Box pr={4} mt={0} fontSize={14} textAlign={'right'}>
          {calculating ? (
            <Box display="inline-block" transform="scale(0.7)" transformOrigin="right center">
              <Dots backgroundColor="#666" />
            </Box>
          ) : (
            formatPrice(showTBC ? cartTotal?.totalPrice / 100 : ts?.total_price)
          )}
        </Box>
      </SimpleGrid>
    </Box>
  )
}

export default ShoppingCartTotals